class concept {
  constructor(rolId, id, name) {
    this.rolId = rolId;
    this.id = id;
    this.name = name;
  }

  static fromJson({ rolId, conceptoId, nomConcepto }) {
    return new concept(rolId, conceptoId, nomConcepto);
  }
}

export default concept;
